import axios from "axios";
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL_EXPENSE = `${config.URL_EXPENSES}/od`;
const BASE_URL_BANK = `${config?.URL_BANKS}/od`;

const request = async (method, endpoint, data = null, params = null, baseUrl = BASE_URL_EXPENSE) => {
  const url = `${baseUrl}${endpoint}`;
  try {
    const headers = await headers_get();
    return await axios({ method, url, data, params, headers });
  } catch (error) {
    console.error(`Error in ${method.toUpperCase()} ${url}:`, error?.response?.data || error.message);
    throw error;
  }
};


// 🔹 Gestión de Gastos (Expenses)
export const expenses_get = async (fi, ff, type, rfc, bp) => request("get", "/expenses", null, { di: fi, df: ff, origin: type, rfc: rfc, bp: bp, });

export const expenses_concept_list_get = async (foreign) => request("get", "/expenses/concept-list", null, { foreign: foreign });

export const expenses_post = async (data) => request("post", "/expenses", data);

export const expenses_put = async (id, data) => request("put", `/expenses/${id}`, data);

export const expenses_delete = async (id) => request("delete", `/expenses/${id}`);

export const expenses_download = async (id) => request("get", `/expenses/${id}`);

export const expenses_file_get = async (id) => request("get", `/expenses/${id}`);

export const expenses_details_get = async (id) => request("get", `/expenses/${id}/details`);

export const expenses_details_post = async (id, data) => request("post", `/expenses/${id}/details`, data);

export const expenses_details_put = async (id, idd, data) => request("put", `/expenses/${id}/details/${idd}`, data);

export const expenses_details_delete = async (id, idd) => request("delete", `/expenses/${id}/details/${idd}`);

export const expenses_group_post = async (data) => request("post", "/expenses/group", data);

export const supplier_get = async () => request("get", "/businesspartners");

export const payment_account_get = async () => request("get", "/payment-accounts", null, BASE_URL_BANK);

export const expense_payment_account_get = async () => request("get", "/paymentaccounts", null);



// 🔹 Gestión de Facturas de Proveedores (Supplier Invoices)
export const supplier_invoices_get = async (fi, ff) => request("get", "/supplier-invoices", null, { di: fi, df: ff });

export const supplier_invoices_post = async (data) => request("post", "/supplier-invoices", data);

export const supplier_invoices_delete = async (id) => request("delete", `/supplier-invoices/${id}`);

export const supplier_invoices_download = async (id, file_name, document_type) =>
  request("get", `/supplier-invoices/${id}`, null, {
    filename: file_name,
    documentType: document_type,
  });